import type { LocalDate, ZonedDateTime } from '@spa-frontend/date-lib';

type Sortable =
    | number
    | string
    | LocalDate
    | ZonedDateTime
    | null
    | boolean
    | undefined;

export const sortByFn =
    <T, P extends Sortable>(getProp: (t: T) => P) =>
    (a: T, b: T) =>
        compare(getProp(a), getProp(b));

export const compare = <T extends Sortable>(a: T, b: T) => {
    if ((a === undefined || a === null) && (b === undefined || b === null)) {
        return 0;
    }
    if (a === undefined || a === null) {
        return 1;
    }
    if (b === undefined || b === null) {
        return -1;
    }

    const typeA = typeof a;
    const typeB = typeof b;

    if (typeA === 'number' && typeB === 'number') {
        return (a as number) - (b as number);
    }

    if (typeA === 'string' && typeB === 'string') {
        return (a as string).localeCompare(b as string, 'en', {
            numeric: true
        });
    }
    return (
        ((a as object)?.valueOf() as number) -
        ((b as object)?.valueOf() as number)
    );
};
